import { render, staticRenderFns } from "./departmentView.vue?vue&type=template&id=2887f9fe"
import script from "./departmentView.vue?vue&type=script&lang=js"
export * from "./departmentView.vue?vue&type=script&lang=js"
import style0 from "./departmentView.vue?vue&type=style&index=0&id=2887f9fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports